import prefixAll from 'inline-style-prefixer/static';
import React from 'react';

import './styles.less';

const PlayProgressBar = ({
  onMouseMove,
  onMouseOut,
  progress,
  slider,
  sliderWidth,
  inTrimMode,
}) => {
  if (slider == null) {
    return null;
  }

  const style = prefixAll({
    transform: `translateX(-${(1 - progress) * sliderWidth}px)`,
  });

  return (
    <div
      className="video-player-play-progress-bar-container"
      onMouseMove={onMouseMove}
      onMouseOut={onMouseOut}
    >
      <div
        className={`video-player-play-progress-bar ${
          inTrimMode ? 'trim-mode' : ''
        }`}
        style={style}
      />
    </div>
  );
};

export default PlayProgressBar;
